module.exports = __webpack_public_path__ + "static/media/button_barcode.ec58abb7.png";